var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "AftercareCart" }, [
    _c("div", { staticClass: "AftercareCart--title" }, [
      _c(
        "div",
        {
          staticClass: "AftercareCart--title-name",
          attrs: { title: _vm.aftercare.aftercareName }
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.aftercare.aftercareName) +
              "\n        "
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "AftercareCart--title-date" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm._f("timeFormatL")(_vm.aftercare.aftercareStartDate)) +
            " - " +
            _vm._s(_vm._f("timeFormatL")(_vm.aftercare.aftercareEndDate)) +
            "\n        "
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "AftercareCart--second" }, [
      _c("div", { staticClass: "AftercareCart--second-location" }, [
        _c("img", {
          attrs: { src: require("../../../../assets/img/svg/map-pin.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "AftercareCart--second-location-name" }, [
          _vm._v(_vm._s(_vm.aftercare.locationName))
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("strong", { style: { "margin-right": "10px" } }, [
            _vm._v("Sessions Fees:")
          ]),
          _vm._v(" "),
          _vm.aftercare.price === 0
            ? _c("span", { staticClass: "font-weight-bold text-green" }, [
                _vm._v("\n                    FREE\n                ")
              ])
            : _c("span", { staticClass: "AftercareCart--second-price" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm._f("currencySign")(_vm.schoolCurrency)) +
                    " " +
                    _vm._s(_vm._f("priceFormat")(_vm.aftercare.price)) +
                    "\n                    "
                ),
                _vm.aftercare.billingRate !== "FIXED"
                  ? _c("span", [
                      _vm._v(
                        " / " +
                          _vm._s(
                            _vm._f("toCapitalize")(_vm.aftercare.billingRate)
                          )
                      )
                    ])
                  : _vm._e()
              ])
        ]),
        _vm._v(" "),
        _vm.aftercare.dropIn
          ? _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("strong", { style: { "margin-right": "15px" } }, [
                _vm._v("Drop-in Fees:")
              ]),
              _vm._v(" "),
              _vm.aftercare.dropInPrice === 0
                ? _c("span", { staticClass: "font-weight-bold text-green" }, [
                    _vm._v("\n                    FREE\n                ")
                  ])
                : _c("span", { staticClass: "AftercareCart--second-price" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm._f("currencySign")(_vm.schoolCurrency)) +
                        " " +
                        _vm._s(
                          _vm._f("priceFormat")(_vm.aftercare.dropInPrice)
                        ) +
                        "\n                    "
                    ),
                    _vm.aftercare.dropInBillingRate !== "FIXED"
                      ? _c("span", [
                          _vm._v(
                            "/ " +
                              _vm._s(
                                _vm._f("toCapitalize")(
                                  _vm.aftercare.dropInBillingRate
                                )
                              )
                          )
                        ])
                      : _vm._e()
                  ])
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "AftercareCart--content" }, [
      _c(
        "div",
        { staticClass: "AftercareCart--content-info" },
        [
          _c("p", {
            class: _vm.isOpened
              ? "AftercareCart--content-info-text-full"
              : "AftercareCart--content-info-text-small",
            domProps: { innerHTML: _vm._s(_vm.aftercare.description) }
          }),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            !_vm.isOpened
              ? _c("div", { staticClass: "description-shadow" })
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "AftercareCart--content-more",
          on: { click: _vm.toggleCart }
        },
        [
          _c(
            "i",
            {
              staticClass: "material-icons down",
              class: _vm.isOpened ? "rotated" : "rotatedBack"
            },
            [_vm._v("keyboard_arrow_down")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "AftercareCart--content-table" },
        [
          _c("div", { staticClass: "AftercareCart--content-table-header" }, [
            _c(
              "div",
              { staticClass: "AftercareCart--content-table-header-info" },
              [
                _c(
                  "h6",
                  { staticClass: "AftercareCart--content-table-header-title" },
                  [_vm._v("Days")]
                ),
                _vm._v(" "),
                _c(
                  "h6",
                  { staticClass: "AftercareCart--content-table-header-title" },
                  [
                    _vm.schoolCountry === "England"
                      ? _c("span", [_vm._v("Age/Year")])
                      : _c("span", [_vm._v("Age/Grades")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h6",
                  { staticClass: "AftercareCart--content-table-header-title" },
                  [_vm._v("Time")]
                ),
                _vm._v(" "),
                _c(
                  "h6",
                  { staticClass: "AftercareCart--content-table-header-title" },
                  [_vm._v("Max")]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.aftercare.days, function(day) {
            return _c(
              "div",
              { key: day.id, staticClass: "AftercareCart--content-table-day" },
              [
                _c("aftercare-day-cart", {
                  attrs: { session: day, aftercare: _vm.aftercare },
                  on: {
                    open: function($event) {
                      return _vm.$emit("open", day)
                    }
                  }
                })
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.aftercare.dropIn
            ? [
                _c(
                  "div",
                  { staticClass: "AftercareCart--content-table-footer" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "AftercareCart--content-table-footer-title"
                      },
                      [_vm._v("DROP-IN")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "AftercareCart--content-table-footer-button"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "primary-btn",
                            attrs: {
                              disabled: _vm.aftercare.dropInStatus === "Closed"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.$emit("drop-in")
                              }
                            }
                          },
                          [
                            _vm.aftercare.dropInStatus === "Online"
                              ? [_vm._v(" Add ")]
                              : _vm.aftercare.dropInStatus === "Closed"
                              ? [_vm._v(" Closed ")]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    )
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce61213e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce61213e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/pages/Activities/AftercareCart.vue
// module id = null
// module chunks = 